import SuperadminLayout from '../../components/SuperadminLayout';
import SuperadminOtpConfig from './SuperadminOtpConfig';
import SuperadminPasswordCard from './SuperadminPasswordCard';
import SuperadminSeasonalCard from './SuperadminSeasonalCard';

// Superadmin → Ayarlar: ümumi superadmin konfiqləri (şifrə, OTP və s.).
export default function Settings() {
    return (
        <SuperadminLayout title="Ayarlar" subtitle="Superadmin sistem konfiqurasiyası">
            <div className="space-y-5">
                <SuperadminPasswordCard />
                <SuperadminSeasonalCard />
                <SuperadminOtpConfig />
            </div>
        </SuperadminLayout>
    );
}
